import superagentPromisePlugin from 'superagent-promise-plugin'

import http_agent from './http_agent'
import http_request from './http_request'
import config from 'config'
import { detectLanguage } from '../helpers/functions'

const language = detectLanguage()

function _genericCatch() {
	return {
		valid: false,
		message: 'Something went wrong. Please try again later.',
	}
}

function validatePin(pincode) {
	return http_agent.post(config.hub + 'session/valid_pin')
		.type('form')
		.send({
			pincode: pincode||'',
			language,
		})
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			if (payload.error_code === 0) {
				return {
					valid: true,
				}
			} else {
				return {
					valid: false,
					message: payload.message,
				}
			}
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function validateReferral(promoCode) {
	return http_agent.post(config.services + 'user/validations/isValidPromoCode.php')
		.send({
			promoCode: promoCode||'',
			language,
		})
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text).payload
			if (payload.isValid) {
				return {
					valid: true,
				}
			} else {
				return {
					valid: false,
					message: 'global_invalidReferral',
				}
			}
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function getPasswordConditions(recoveryKey) {
	return http_agent
		.post(config.services + 'user/validations/getPswConditions.php')
		.use(superagentPromisePlugin)
		.send({
			recoveryKey,
			language,
		})
		.then(response => {
			const payload = JSON.parse(response.text).payload
			return payload

		})
		.catch(function() {
			// console.log(err)
		})
}

function sendEmailSignupForm(values, isTeacher, obLessonData) {
	return http_agent.post(config.services + 'service.php?' + location.search.substr(1))
		.send(
			{
				method: 'validateUserAndCreate',
				unifiedLogin: 1,
				isTeacher,
				firstName: values.firstname,
				lastName: values.lastname,
				email: values.email,
				password: values.password,
				promoCode: values.promoCode,
				'g-recaptcha-response': values.recaptcha,
				obUID: obLessonData && obLessonData.obEntityUID ? obLessonData.obEntityUID : 0,
				language,
			})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function sendSsoSignupForm(values, obLessonData) {
	return http_agent.post(config.services + 'user/ssoSignup.php')
		.send(
			{
				btbt: !!values.isBytebot,
				sk: values.sk,
				promoCode: values.referral,
				obEntityUID: obLessonData && obLessonData.obEntityUID ? obLessonData.obEntityUID : 0,
				obEntityType: obLessonData && obLessonData.obEntityType ? obLessonData.obEntityType : '',
				language,
			})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(response => {
			response = JSON.parse(response.text)
			if (response.error_code === 0) {
				return {
					valid: true,
					data: response.payload,
				}
			} else {
				return {
					valid: false,
					message: response.message,
				}
			}
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function sendLoginForm(values, fromLTI, referer) {
	return http_agent.post(config.services + 'service.php')
		.send(
			{
				method: 'login',
				onlyDoLogin: true,
				user: values.email,
				password: values.password,
				rememberMe: values.remember,
				language,
				fromLTI,
				referer,
			})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			response = JSON.parse(response.text)
			return response
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function autoLogin() {
	return http_agent.post(config.services + 'service.php')
		.send({
			method: 'userLogged',
			onlyDoLogin: true,
			getMetricsStatus: 1,
			language,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			response = JSON.parse(response.text)
			if (response.error_code === 0) {
				return {
					logged: true,
					error_code: 0,
					data: response.payload,
				}
			} else {
				return {
					error_code: response.error_code,
					logged: false,
					metrics: response.payload.metrics,
				}
			}
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function sendForgotPasswordForm(values) {
	return http_agent.post(config.services + 'user/forgotPassword.php')
		.send({
			username: values.email,
			'g-recaptcha-response': values.recaptcha,
			language,
		})
		.use(superagentPromisePlugin)
		.then(function(response) {
			response = JSON.parse(response.text)
			return response
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function validateRecoveryKey(key) {
	return http_agent.post(config.services + 'user/validations/isValidRecoveryKey.php')
		.send({
			p: key,
			language,
		})
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text).payload
			if (payload.isValid) {
				return {
					valid: true,
					mustAcceptTerms: payload.mustAcceptTerms,
				}
			} else {
				return {
					valid: false,
					message: payload.errorMessage,
				}
			}
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function sendNewPasswordForm(values) {
	return http_agent.post(config.services + 'user/resetPassword.php')
		.send({
			p: values.recoveryKey,
			newPassword: values.password,
			redirect: values.redirect,
			terms: values.terms,
			language,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			response = JSON.parse(response.text)
			if (response.error_code === 0) {
				return {
					valid: true,
					message: response.message,
					redirectUrl: response.payload.redirectUrl,
				}
			} else {
				return {
					valid: false,
					errorCode: response.error_code,
					message: response.message,
				}
			}
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function getUserToken(sk) {
	return http_request.get(config.api + 'bytebot/token')
		.send({
			sk,
		})
}

function loginViaBytebot(id) {
	return http_request.post(config.api + 'bytebot')
		.send({
			id,
		})
}

function submitGoogleToken(token) {
	return http_agent.post(`${config.auth_gateway}auth/google-login`)
		.send()
		.set('Authorization', 'Bearer ' + token)
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			return {
				jwt: response.header['access-token'],
			}
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function submitOffice365Token(token) {
	return http_agent.post(`${config.auth_gateway}auth/microsoft-login`)
		.send()
		.set('Authorization', 'Bearer ' + token)
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			return {
				jwt: response.header['access-token'],
			}
		})
		.catch(err => {
			_genericCatch(err)
		})
}

export default {
	validatePin,
	validateReferral,
	getPasswordConditions,
	sendEmailSignupForm,
	sendSsoSignupForm,
	sendLoginForm,
	autoLogin,
	sendForgotPasswordForm,
	validateRecoveryKey,
	sendNewPasswordForm,
	loginViaBytebot,
	getUserToken,
	submitGoogleToken,
	submitOffice365Token,
}
